/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
], function() {

	class DefaultEventMapProvider  {
		constructor({ content, features }) {
			this.features = features;
			this.content = content;
			this.features['EventMap'].registerEvents(this._getEventMapList());
			this.eventMap = null;
		}

		initialize() {
			return Promise.resolve();
		}

		_getVisualizationGesture(){
			//We don't cache feature here, because it is cached at feature loader level; 
			//If we cache, it could go stale when switching vis type 
			return this.content.getFeature('VisualizationGesture.internal');
		}

		_getEventMapList(){
			if (!this.eventMap){
				this.eventMap = [];
				const panAndZoomEvents = [{
					'gesture':  this.features['EventMap'].GESTURES.MOUSE_DOWN,
					'key': 'mousedown',
					'callback': (event) => this._getVisualizationGesture().onMouseDown(event)
				}, {
					'gesture':  this.features['EventMap'].GESTURES.MOUSE_UP,
					'key': 'mouseup',
					'callback': (event) => this._getVisualizationGesture().onMouseUp(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.WHEEL,
					'key': 'mousewheel wheel',
					'callback': (event) => this._getVisualizationGesture().onMouseWheel(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.PAN_START,
					'key': 'touchstart',
					'callback': (event) => this._getVisualizationGesture().onClickTapPanStart(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.PAN_END,
					'key': 'touchend',
					'callback': (event) => this._getVisualizationGesture().onPanEnd(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.PAN_MOVE,
					'key': 'touchmove',
					'callback': (event) => this._getVisualizationGesture().onPanMove(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.ZOOM_START,
					'key': 'transformstart',
					'callback': (event) => this._getVisualizationGesture().onPinchStart(event),
					'hammer': true
				}, {
					'gesture': this.features['EventMap'].GESTURES.ZOOM,
					'key': 'transform',
					'callback': (event) => this._getVisualizationGesture().onPinch(event),
					'hammer': true
				}, {
					'gesture': this.features['EventMap'].GESTURES.ZOOM_END,
					'key': 'transformend',
					'callback': (event) => this._getVisualizationGesture().onPinchEnd(event),
					'hammer': true
				}];

				const hoverEvents = [{
					'gesture': this.features['EventMap'].GESTURES.HOVER,
					'key': 'mousemove touchmove',
					'callback': (event) => this._getVisualizationGesture().onHover(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.HOVER_END,
					'key': 'mouseleave touchend',
					'callback': (event) => this._getVisualizationGesture().onMouseLeave(event)
				}];

				const clickEvents = [{
					'gesture': this.features['EventMap'].GESTURES.MENU,
					'key': 'contextmenu',
					'callback': (event) => this._getVisualizationGesture().onClick(event)
				}, {
					'gesture': this.features['EventMap'].GESTURES.SELECT,
					'key': 'clicktap',
					'callback': (event) => this._getVisualizationGesture().onClickTapPanStart(event),
					'data': { allowPropagationDefaultAction: true }
				}, {
					'gesture': this.features['EventMap'].GESTURES.MULTI_SELECT,
					'key': 'hold',
					'callback': (event) => this._getVisualizationGesture().onHold(event),
					'hammer': true
				}];

				const keyEvents = [{
					'gesture': this.features['EventMap'].GESTURES.KEY_DOWN,
					'key': 'keydown',
					'callback': (event) => this._getVisualizationGesture().onKeyDown(event)
				}];

				this.eventMap.push(...clickEvents, ...keyEvents, ...panAndZoomEvents, ...hoverEvents);

			}
			return this.eventMap;

		}
	}
	return DefaultEventMapProvider;
});
